/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Bright_Deer_LeapInputs */

const en_warm_bright_deer_leap = /** @type {(inputs: Warm_Bright_Deer_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer image`)
};

const de_warm_bright_deer_leap = /** @type {(inputs: Warm_Bright_Deer_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kundenbild`)
};

/**
* | output |
* | --- |
* | "Customer image" |
*
* @param {Warm_Bright_Deer_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_bright_deer_leap = /** @type {((inputs?: Warm_Bright_Deer_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Bright_Deer_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_bright_deer_leap(inputs)
	return de_warm_bright_deer_leap(inputs)
});